import React, { useState, useEffect, useRef } from "react";
import Video from "twilio-video";

const Participant = (props) => {
  const { participant, localParticipant, camera } = props;
  const [videoTracks, setVideoTracks] = useState([]);
  const [audioTracks, setAudioTracks] = useState([]);

  const videoRef = useRef();
  const audioRef = useRef();

  const trackpubsToTracks = (trackMap) =>
    Array.from(trackMap.values())
      .map((publication) => publication.track)
      .filter((track) => track !== null);

  useEffect(() => {
    setVideoTracks(trackpubsToTracks(participant.videoTracks));
    setAudioTracks(trackpubsToTracks(participant.audioTracks));

    const trackSubscribed = (track) => {
      if (track.kind === "video") {
        setVideoTracks((videoTracks) => [...videoTracks, track]);
      } else if (track.kind === "audio") {
        setAudioTracks((audioTracks) => [...audioTracks, track]);
      }
    };

    const trackUnsubscribed = (track) => {
      if (track.kind === "video") {
        setVideoTracks((videoTracks) => videoTracks.filter((v) => v !== track));
      } else if (track.kind === "audio") {
        setAudioTracks((audioTracks) => audioTracks.filter((a) => a !== track));
      }
    };

    participant.on("trackSubscribed", trackSubscribed);
    participant.on("trackUnsubscribed", trackUnsubscribed);

    return () => {
      setVideoTracks([]);
      setAudioTracks([]);
      participant.removeAllListeners();
    };
  }, [participant]);

  useEffect(() => {
    async function handleSwitch() {
      if (localParticipant) {
        const currentVideoTracks = Array.from(
          participant.videoTracks.values()
        ).map((trackPublication) => trackPublication.track);

        participant.videoTracks.forEach((trackPublication) => {
          trackPublication.track.stop();
        });

        participant.unpublishTracks(currentVideoTracks);

        const newVideoTrack = await Video.createLocalVideoTrack({
          facingMode: camera === 1 ? "user" : "environment",
        });
        participant.publishTrack(newVideoTrack);
        const newVideoTracks = [newVideoTrack].concat(
          videoTracks.filter((v, idx) => parseInt(idx) === 0)
        );
        setVideoTracks(newVideoTracks);
      }
    }
    handleSwitch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [camera]);

  useEffect(() => {
    const videoTrack = videoTracks[0];
    if (videoTrack) {
      videoTrack.attach(videoRef.current);
      return () => {
        videoTrack.detach();
      };
    }
  }, [videoTracks]);

  useEffect(() => {
    const audioTrack = audioTracks[0];
    if (audioTrack) {
      audioTrack.attach(audioRef.current);
      return () => {
        audioTrack.detach();
      };
    }
  }, [audioTracks]);

  return (
    <div className="participant">
      <video ref={videoRef} autoPlay={true} className="video-call" />
      <audio ref={audioRef} autoPlay={true} muted={false} />
    </div>
  );
};

export default Participant;
